import { FEATURE_FLAGS_EXTERNAL_USERS } from 'appConstants';
import { getInitialAppType } from 'utils';

import {
  RESET_APPLICATION_TYPE,
  SET_APPLICATION_TYPE,
  SET_USER_SETTINGS,
  USER_SETTINGS_ERROR,
  USER_SETTINGS_LOADING,
} from './actionTypes';
import { type IAppSettings } from './types';

const initialAppSettings: IAppSettings = {
  SEED: {},
  CROP: {},
  FERTILISER: {},
  SHARED: {},
};

export const initialState = {
  applicationType: getInitialAppType(),
  userSettings: {
    isAdmin: false,
    isGroupUser: false,
    isInternalUser: false,
    APP_SETTINGS: initialAppSettings,
  },
  userSettingsLoading: false,
  userSettingsRequested: false,
  isGroupUser: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case SET_APPLICATION_TYPE:
      return { ...state, applicationType: action.payload };
    case RESET_APPLICATION_TYPE:
      return { ...state, applicationType: null };
    case USER_SETTINGS_LOADING:
      return { ...state, userSettingsLoading: true };
    case SET_USER_SETTINGS:
      return {
        ...state,
        userSettings: action.payload,
        isGroupUser: FEATURE_FLAGS_EXTERNAL_USERS && action.payload?.isGroupUser,
        userSettingsLoading: false,
        userSettingsRequested: true,
      };
    case USER_SETTINGS_ERROR:
      return {
        ...state,
        userSettings: null,
        userSettingsLoading: false,
        userSettingsRequested: true,
      };
    default:
      return state;
  }
};
